// Generated by Melange

import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__ErrorPage from "../ErrorPage.js";
import * as Buhta_cabinet__Kassa from "../../grpc/Kassa.js";
import * as Buhta_cabinet__KassaSubheader from "../../components/molecules/OrgDashboardHeader/KassaSubheader.js";
import * as Buhta_cabinet__KkmCloseShiftModal from "../../components/organisms/Kassa/KKM/KkmCloseShiftModal.js";
import * as Buhta_cabinet__KkmMoneyPlacementModal from "../../components/organisms/Kassa/KKM/KkmMoneyPlacementModal.js";
import * as Buhta_cabinet__KkmView from "../../components/organisms/Kassa/KKM/KkmView.js";
import * as Buhta_cabinet__Link from "../../components/html/Link.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__OrgDashboardHeaderMobile from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeaderMobile.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_components__Colors from "../../../../../packages/components/src/Colors.js";
import * as Buhta_components__TopLoadingBar from "../../../../../packages/components/src/atoms/TopLoadingBar.js";
import * as Buhta_core__GlobalStateContext from "../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_core__GrpcState from "../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function KkmViewPage(Props) {
  let id = Props.id;
  let org = Props.org;
  let openMenu = Props.openMenu;
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const match$1 = React.useState(function () {
    return false;
  });
  const setMoneyPlacementModal = match$1[1];
  const match$2 = React.useState(function () {
    return false;
  });
  const setCloseShiftModal = match$2[1];
  const match$3 = React.useState(function () {
    return true;
  });
  const setIsMoneyIn = match$3[1];
  const isMoneyIn = match$3[0];
  const match$4 = React.useState(function () {
    return /* Complete */ 1;
  });
  const setBarState = match$4[1];
  const func = Buhta_cabinet__Kassa.KkmManagerService.view;
  const match$5 = Buhta_core__GrpcState.useModel((function (param) {
    return Curry._3(func, param, /* [] */ 0, id);
  }), undefined);
  const dispatch = match$5[1];
  const kkmObj = match$5[0];
  React.useEffect((function () {
    Curry._2(dispatch, undefined, undefined);
  }), [id]);
  const title = typeof kkmObj === "string" ? (
      kkmObj === "Loading" ? "loading" : ""
    ) : (
      kkmObj.NAME === "Data" ? kkmObj.VAL.name : ""
    );
  const backButton = JsxRuntime.jsx(Buhta_cabinet__Link.make, {
    route: contextRoute({
      TAG: /* Kassa */ 2,
      _0: {
        TAG: /* Kkms */ 0,
        _0: /* List */ 1
      }
    }),
    children: JsxRuntime.jsx("img", {
      className: "w-5 h-5",
      src: StaticAsset.src("/static/icons/back-arrow.svg")
    })
  });
  const subheader = typeof kkmObj === "string" || kkmObj.NAME !== "Data" ? null : JsxRuntime.jsx(Buhta_cabinet__KassaSubheader.make, {
      currentRoute: currentRoute,
      kkm: kkmObj.VAL,
      contextRoute: contextRoute
    });
  const header = deviceType === "mobile" ? JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeaderMobile.make, {
      title: title,
      leftChildren: backButton,
      openMenu: openMenu,
      subheader: subheader
    }) : JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
      title: title
    });
  React.useEffect((function () {
    if (kkmObj === "Loading") {
      Curry._1(setBarState, (function (param) {
        return /* Start */ 0;
      }));
    } else {
      Curry._1(setBarState, (function (param) {
        return /* Complete */ 1;
      }));
    }
  }), [kkmObj]);
  return JsxRuntime.jsxs(Buhta_cabinet__DashboardContentTemplate.make, {
    header: header,
    children: [
      JsxRuntime.jsx(Buhta_components__TopLoadingBar.make, {
        color: Buhta_components__Colors.links,
        height: 3,
        state: match$4[0]
      }),
      typeof kkmObj === "string" ? (
          kkmObj === "Loading" ? JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    className: "bg-gray-pale rounded-sm w-12 h-4"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                            className: "bg-gray-pale w-16 h-10 rounded"
                          }),
                          JsxRuntime.jsx("div", {
                            className: "bg-gray-pale w-20 h-6 rounded-sm ml-2"
                          })
                        ],
                        className: "flex items-center"
                      }),
                      JsxRuntime.jsx("div", {
                        className: "bg-gray-pale w-13 h-5 rounded"
                      })
                    ],
                    className: "mt-1 flex justify-between items-center"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                        className: "bg-gray-pale w-full h-10 rounded"
                      }),
                      JsxRuntime.jsx("div", {
                        className: "bg-gray-pale w-full h-10 rounded"
                      })
                    ],
                    className: "flex gap-2 mt-6"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                            className: "bg-gray-pale w-5 h-5 rounded"
                          }),
                          JsxRuntime.jsx("div", {
                            className: "bg-gray-pale w-28 h-5 rounded-sm ml-2"
                          })
                        ],
                        className: "flex items-center"
                      }),
                      JsxRuntime.jsx("div", {
                        className: "bg-gray-pale w-20 h-5 rounded"
                      })
                    ],
                    className: "mt-6 flex justify-between items-center"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                            className: "bg-gray-pale w-5 h-5 rounded"
                          }),
                          JsxRuntime.jsx("div", {
                            className: "bg-gray-pale w-16 h-5 rounded-sm ml-2"
                          })
                        ],
                        className: "flex items-center"
                      }),
                      JsxRuntime.jsx("div", {
                        className: "bg-gray-pale w-32 h-5 rounded"
                      })
                    ],
                    className: "mt-2 flex justify-between items-center"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                            className: "bg-gray-pale w-5 h-5 rounded"
                          }),
                          JsxRuntime.jsx("div", {
                            className: "bg-gray-pale w-16 h-5 rounded-sm ml-2"
                          })
                        ],
                        className: "flex items-center"
                      }),
                      JsxRuntime.jsx("div", {
                        className: "bg-gray-pale w-25 h-5 rounded"
                      })
                    ],
                    className: "mt-2 flex justify-between items-center"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                            className: "bg-gray-pale w-5 h-5 rounded"
                          }),
                          JsxRuntime.jsx("div", {
                            className: "bg-gray-pale w-15 h-5 rounded-sm ml-2"
                          })
                        ],
                        className: "flex items-center"
                      }),
                      JsxRuntime.jsx("div", {
                        className: "bg-gray-pale w-28 h-5 rounded"
                      })
                    ],
                    className: "mt-2 flex justify-between items-center"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                            className: "bg-gray-pale w-5 h-5 rounded"
                          }),
                          JsxRuntime.jsx("div", {
                            className: "bg-gray-pale w-32 h-5 rounded-sm ml-2"
                          })
                        ],
                        className: "flex items-center"
                      }),
                      JsxRuntime.jsx("div", {
                        className: "bg-gray-pale w-20 h-5 rounded"
                      })
                    ],
                    className: "mt-2 flex justify-between items-center"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                            className: "bg-gray-pale w-5 h-5 rounded"
                          }),
                          JsxRuntime.jsx("div", {
                            className: "bg-gray-pale w-28 h-5 rounded-sm ml-2"
                          })
                        ],
                        className: "flex items-center"
                      }),
                      JsxRuntime.jsx("div", {
                        className: "bg-gray-pale w-12 h-5 rounded"
                      })
                    ],
                    className: "mt-2 flex justify-between items-center"
                  }),
                  JsxRuntime.jsx("div", {
                    className: "mt-6 bg-gray-pale rounded-sm w-full h-10"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                        className: "bg-gray-pale w-full h-10 rounded"
                      }),
                      JsxRuntime.jsx("div", {
                        className: "bg-gray-pale w-full h-10 rounded"
                      })
                    ],
                    className: "flex gap-2 mt-4"
                  }),
                  JsxRuntime.jsx("hr", {
                    className: "mt-6"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                        className: "bg-gray-pale w-29 h-5 rounded"
                      }),
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                            className: "bg-gray-pale w-30 h-5 rounded"
                          }),
                          JsxRuntime.jsx("div", {
                            className: "bg-gray-pale w-5 h-5 rounded-sm ml-2"
                          })
                        ],
                        className: "flex items-center"
                      })
                    ],
                    className: "mt-6 flex justify-between items-center"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                        className: "bg-gray-pale w-18 h-5 rounded"
                      }),
                      JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                            className: "bg-gray-pale w-26 h-5 rounded"
                          }),
                          JsxRuntime.jsx("div", {
                            className: "bg-gray-pale w-5 h-5 rounded-sm ml-2"
                          })
                        ],
                        className: "flex items-center"
                      })
                    ],
                    className: "mt-2 flex justify-between items-center"
                  }),
                  JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                        className: "bg-gray-pale w-34 h-5 rounded"
                      }),
                      JsxRuntime.jsx("div", {
                        className: "bg-gray-pale w-21 h-5 rounded"
                      })
                    ],
                    className: "mt-2 flex justify-between items-center"
                  })
                ],
                className: "w-full lg:w-110 bg-white p-6 rounded-md shadow-kkms"
              }),
              className: "px-4 lg:px-6 py-6 bg-gray-pale w-full flex flex-col lg:flex-row gap-6 items-start"
            }) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {})
        ) : (
          kkmObj.NAME === "Data" ? JsxRuntime.jsx(Buhta_cabinet__KkmView.make, {
              kkm: kkmObj.VAL,
              onMoneyPlacement: (function (value) {
                Curry._1(setIsMoneyIn, (function (param) {
                  return value;
                }));
                Curry._1(setMoneyPlacementModal, (function (param) {
                  return true;
                }));
              }),
              onCloseShift: (function (param) {
                Curry._1(setCloseShiftModal, (function (param) {
                  return true;
                }));
              }),
              org: org
            }) : JsxRuntime.jsx(Buhta_cabinet__ErrorPage.make, {})
        ),
      match$1[0] ? (
          deviceType === "mobile" ? JsxRuntime.jsx(Buhta_cabinet__KkmMoneyPlacementModal.Mobile.make, {
              onClose: (function (param) {
                Curry._1(setMoneyPlacementModal, (function (param) {
                  return false;
                }));
              }),
              isMoneyIn: isMoneyIn,
              id: id
            }) : JsxRuntime.jsx(Buhta_cabinet__KkmMoneyPlacementModal.Desktop.make, {
              onClose: (function (param) {
                Curry._1(setMoneyPlacementModal, (function (param) {
                  return false;
                }));
              }),
              isMoneyIn: isMoneyIn,
              id: id
            })
        ) : null,
      match$2[0] ? JsxRuntime.jsx(Buhta_cabinet__KkmCloseShiftModal.make, {
          onClose: (function (param) {
            Curry._1(setCloseShiftModal, (function (param) {
              return false;
            }));
            Curry._2(dispatch, undefined, undefined);
          }),
          id: id,
          org: org.id
        }) : null
    ]
  });
}

const make = KkmViewPage;

export {
  make,
}
/* Buhta_cabinet__DashboardContentTemplate Not a pure module */
